/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState, useEffect } from 'react'
import './TopBar.scss'
import { format } from 'date-fns'

const TimeWrapper = () => {
  const [time, setTime] = useState(new Date())

  useEffect(() => {
    const interval = setInterval(() => setTime(new Date()), 1000)

    return () => {
      clearInterval(interval)
    }
  }, [])

  return (
    <div className="iar-time-wrapper">
      <div className="dayDate">
        <span id="date-text" className="{styles.day}">{`${format(time, 'iiii')}`}</span>
        <span id="date-text">{`${format(time, 'MMMMMM')} ${format(time, 'd')}, ${format(
          time,
          'y'
        )}`}</span>
      </div>
    </div>
  )
}
export default TimeWrapper
